module.exports = __webpack_public_path__ + "img/DPO-SA.e26d8ced.svg";